import React, { useState } from "react";
import APIs from "../../APIs";
import { toast } from "react-toastify";
const Contact = () => {
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    mobile_number: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [statusMessage, setStatusMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" }); // clear error on change
  };

  // Client-side validation
  const validate = () => {
    const newErrors = {};
    if (!formData.full_name.trim()) newErrors.full_name = "Name is required.";
    if (!formData.email.trim()) newErrors.email = "Email is required.";
    if (!formData.mobile_number.trim()) newErrors.mobile_number = "Phone number is required.";
    if (!formData.subject.trim()) newErrors.subject = "Subject is required.";
    if (!formData.message.trim()) newErrors.message = "Message is required.";
    return newErrors;
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setStatusMessage("");
  setLoading(true);

  const validationErrors = validate();
  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);
    setLoading(false);
    return;
  }

  try {
    // Correct Axios POST
    const response = await APIs.post("user/addFeedback", formData);

    // Axios automatically parses JSON
    const data = response.data;

    toast.success(data.message || "Feedback submitted successfully!",{position: "top-right"});
    setFormData({ full_name: "", email: "", mobile_number: "", subject: "", message: "" });
    setErrors({});
  } catch (error) {
    toast.error(
      error.response?.data?.message
        ? error.response.data.message
        : "Error submitting feedback: " + error.message
    );
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="page-wrapper">
      <div className="page-content">
        <section className="contact-us-section-two section-md">
          <div className="container">
            <div className="row">
              <div className="col-md-6 contact-left-col">
                <div className="contact-us-two"></div>
              </div>
              <div className="col-md-6 contact-right-col">
                <div className="contact-wrap eagle-bg-color-blackish">
                  <div className="eagle-heading-subheading animation-style2">
                    <h4 className="eagle-subtitle">
                      <span></span>Connect with us!
                    </h4>
                    <h2 className="eagle-title">Do you need help? Contact with us!</h2>
                  </div>
                  <form className="contact-form" onSubmit={handleSubmit} noValidate>
                    <div className="row">
                      <div className="col-sm-12 col-md-6">
                        <input
                          type="text"
                          className={`form-control ${errors.full_name ? "is-invalid" : ""}`}
                          placeholder="Your Name *"
                          name="full_name"
                          value={formData.full_name}
                          onChange={handleChange}
                        />
                        {/* {errors.full_name && <small className="text-danger">{errors.full_name}</small>} */}
                      </div>
                      <div className="col-sm-12 col-md-6">
                        <input
                          type="email"
                          className={`form-control ${errors.email ? "is-invalid" : ""}`}
                          placeholder="Your Email *"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                        {/* {errors.email && <small className="text-danger">{errors.email}</small>} */}
                      </div>
                      <div className="col-sm-12 col-md-6">
                        <input
                          type="tel"
                          className={`form-control ${errors.mobile_number ? "is-invalid" : ""}`}
                          placeholder="Your Phone *"
                          name="mobile_number"
                          value={formData.mobile_number}
                          onChange={handleChange}
                        />
                        {/* {errors.mobile_number && <small className="text-danger">{errors.mobile_number}</small>} */}
                      </div>
                      <div className="col-sm-12 col-md-6">
                        <input
                          type="text"
                          className={`form-control ${errors.subject ? "is-invalid" : ""}`}
                          placeholder="Subject"
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                        />
                        {/* {errors.subject && <small className="text-danger">{errors.subject}</small>} */}
                      </div>
                      <div className="col-md-12">
                        <textarea
                          name="message"
                          cols="40"
                          rows="10"
                          className={`form-control ${errors.message ? "is-invalid" : ""}`}
                          placeholder="Message"
                          value={formData.message}
                          onChange={handleChange}
                        ></textarea>
                        {/* {errors.message && <small className="text-danger">{errors.message}</small>} */}
                      </div>
                      <div className="col-md-12">
                        <button type="submit" className="eagle-btn" disabled={loading}>
                          <span className="eagle-button-text">{loading ? "Submitting..." : "Submit Now"}</span>
                        </button>
                      </div>
                     
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Contact;
